import BoltIcon from '@mui/icons-material/Bolt';
import { Box } from '@mui/material';
import { Formik, FormikProps } from 'formik';
import { memo, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { RoundButton } from '../../Button/RoundButton/RoundButton';
import { Radio, RadioGroupField } from '../../form/RadioGroup/RadioGroup';
import { Popin, PopinCloseButton } from '../../navigation/Popin/Popin';
import { ResourcesAllocateFormValues } from './ResourcesAllocationPopin';

export const ResourcesAllocationForm = memo(function ResourcesAllocationForm({
    onClose,
    onSubmit,
    isLoading,
    initialValues,
}: {
    onClose: () => void;
    onSubmit: (values: ResourcesAllocateFormValues) => void;
    isLoading: boolean;
    initialValues: ResourcesAllocateFormValues;
}) {
    const renderForm = useCallback(
        ({ handleSubmit }: FormikProps<{}>) => (
            <Popin
                width={700}
                sx={{
                    '& .MuiDialogTitle-root': {
                        '& > .MuiSvgIcon-root:first-of-type': {
                            margin: '0',
                        },
                    },
                }}
                title={
                    <>
                        <BoltIcon sx={{ '& .:first-of-type': { margin: '0' } }} />
                        &ensp;
                        <Box flex={1}>
                            <FormattedMessage id="schedule.allocate.title" />
                        </Box>
                        <PopinCloseButton onClose={onClose} />
                    </>
                }
                content={
                    <>
                        <div>
                            <RadioGroupField name={'onlyNotAllocated'}>
                                <Radio value={true}>
                                    <FormattedMessage id="schedule.allocate.partial" />
                                </Radio>
                                <Radio value={false}>
                                    <FormattedMessage id="schedule.allocate.global" />
                                </Radio>
                            </RadioGroupField>
                        </div>
                    </>
                }
                actions={
                    <>
                        <RoundButton color="primary" size="medium" variant="outlined" onClick={onClose}>
                            <FormattedMessage id="schedule.allocate.cancel" />
                        </RoundButton>
                        &emsp;
                        <RoundButton
                            color="primary"
                            size="medium"
                            variant="contained"
                            onClick={() => handleSubmit()}
                            loading={isLoading}
                            disabled={isLoading}
                        >
                            <FormattedMessage id="schedule.allocate.confirm" />
                        </RoundButton>
                    </>
                }
            />
        ),
        [isLoading, onClose],
    );

    return (
        <Formik onSubmit={onSubmit} initialValues={initialValues}>
            {renderForm}
        </Formik>
    );
});
